
import {useNavigate} from 'react-router-dom';
import {Button} from 'antd';

import {INDEX} from '../../config/routes';

import cls from './Result.module.scss'


export const Done = () => {

    const navigate = useNavigate();

    return (

        <div className={cls.page}>

            <h1>✅ Всё верно!</h1>

            <div>Восхищаемся вашей осведомлённостью!</div>

            <div>Напоминаем что подарки получат первые 7 участнико!<br/>
                О результатах сообщим на электронную почту 📩</div>

            <Button onClick={() => navigate(INDEX)}>Хорошо</Button>

        </div>

    )
}


